/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class OidcDiscoveryService {

    constructor(public readonly httpRequest: BaseHttpRequest) {}

    /**
     * @returns any
     * @throws ApiError
     */
    public getOidcDiscoveryGetOidcConfiguration(): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/.well-known/openid-configuration',
        });
    }

    /**
     * @returns any
     * @throws ApiError
     */
    public getOidcDiscoveryGetJwks(): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/.well-known/jwks.json',
        });
    }

}
